import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Btn, Input, Select, Field, Modal } from "@/components/ui-kit";
import { ROLE_LABELS, CLASSIFICATIONS } from "@/lib/constants";

const ROLES = ["admin", "supervisor", "technician", "inventory_manager"];

export function InviteModal({ onClose, onSent }) {
  const [f, setF] = useState({ full_name: "", email: "", role: "technician", security_clearance: "unclassified" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const send = async () => {
    if (!f.full_name || !f.email) { toast.error("Name and email required"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/users/invite", { ...f, email: f.email.trim() });
      toast.success(data.message);
      onSent();
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <Modal open onClose={onClose} title="Invite by Email">
      <div className="space-y-3" data-testid="invite-modal">
        <p className="text-xs text-muted-foreground">They get an email link (valid 24 hours) to set their own password and sign in.</p>
        <Field label="Full Name" required><Input data-testid="inv-name" value={f.full_name} onChange={set("full_name")} /></Field>
        <Field label="Email" required><Input data-testid="inv-email" type="email" value={f.email} onChange={set("email")} /></Field>
        <Field label="Role"><Select data-testid="inv-role" value={f.role} onChange={set("role")}>{ROLES.map((r) => <option key={r} value={r}>{ROLE_LABELS[r]}</option>)}</Select></Field>
        <Field label="Security Clearance"><Select data-testid="inv-clearance" value={f.security_clearance} onChange={set("security_clearance")}>{CLASSIFICATIONS.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}</Select></Field>
        <div className="flex justify-end gap-2">
          <Btn variant="outline" onClick={onClose}>Cancel</Btn>
          <Btn onClick={send} disabled={busy} data-testid="inv-submit">{busy ? "Sending…" : "Send invite"}</Btn>
        </div>
      </div>
    </Modal>
  );
}
